import { getUserBalances } from '$lib/data/main';
import { getAllStrategyData, getScwStrategyPositionsData } from '$lib/data/strategies';
import { getStablesPrices } from '$lib/data/matchaCallData';
import {
	MARKET_DATA_REFRESH,
	STABLES_PRICE_DATA_REFRESH_MATCHA,
	USER_ALL_MARGINS_REFRESH,
	USER_BALANCE_REFRESH
} from '$lib/refreshIntervals';
import { getAllMarkets } from '$lib/data/markets';
import { getMargin } from '$lib/data/userInteract';
import {
	getAllMarginsForAllMarkets,
	getPaginatedOrderHistory,
	getPaginatedTrades
} from '$lib/data/userHoldings';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import { initPusher, unsubscribePusherChannel } from '$lib/ws/pusher';
import { browser } from '$app/environment';
import { ordersRaw } from '$store/orders';
import { positionsRaw } from '$store/positions';
import type { addressType } from '$lib/types/util';
import { userBalances } from '$lib/home/store';
import { get } from 'svelte/store';

//user data refresh
let userBalanceRefreshInterval: ReturnType<typeof setInterval>;
let userMarginRefreshInterval: ReturnType<typeof setInterval>;
let userPositionsRefreshInterval: ReturnType<typeof setInterval>;
let userOrdersRefreshInterval: ReturnType<typeof setInterval>;
let userOrdersHistoryRefreshInterval: ReturnType<typeof setInterval>;
let userHistoryRefreshInterval: ReturnType<typeof setInterval>;
let userAllMarginsRefreshInterval: ReturnType<typeof setInterval>;
let userTradingSeasonStatRefresh: ReturnType<typeof setInterval>;
let userStratPositionsRefreshInterval: ReturnType<typeof setInterval>;

// // presence refresh
// let presenceRefreshInterval: ReturnType<typeof setInterval>;

smartContractWalletAddress.subscribe(async (address) => {
	if (browser) {
		await initPusher(address as addressType);
		if (address) {
			
			// unsubscribe only once
			unsubscribePusherChannel(`perps-v2-account-events-${address}`);
			
			positionsRaw.initialize(address as `0x${string}`);
			ordersRaw.initialize(address as `0x${string}`);
		}
	}
});

async function getUserData() {
	await Promise.all([
		getUserBalances(),
		getMargin(),
		positionsRaw.apiCall({}),
		ordersRaw.apiCall({}),
		getPaginatedOrderHistory(),
		getPaginatedTrades(),
		getAllMarginsForAllMarkets(),
		getScwStrategyPositionsData(),
		getAllStrategyData()
	]);
}
export function setupUserDataRefresh() {
	destroUserDatarefresh();
	getUserData();
	userBalanceRefreshInterval = setInterval(() => {
		getUserBalances();
	}, USER_BALANCE_REFRESH);

	userMarginRefreshInterval = setInterval(() => {
		getMargin();
	}, USER_BALANCE_REFRESH);
	userOrdersHistoryRefreshInterval = setInterval(() => {
		getPaginatedOrderHistory();
	}, USER_BALANCE_REFRESH);
	userHistoryRefreshInterval = setInterval(() => {
		getPaginatedTrades();
	}, USER_BALANCE_REFRESH);
	userAllMarginsRefreshInterval = setInterval(() => {
		getAllMarginsForAllMarkets();
	}, USER_ALL_MARGINS_REFRESH);

	userStratPositionsRefreshInterval = setInterval(() => {
		getScwStrategyPositionsData();
		getAllStrategyData();
	}, USER_BALANCE_REFRESH);
}

export function destroUserDatarefresh() {
	if (userBalanceRefreshInterval !== undefined) clearInterval(userBalanceRefreshInterval);
	if (userMarginRefreshInterval !== undefined) clearInterval(userMarginRefreshInterval);
	if (userPositionsRefreshInterval !== undefined) clearInterval(userPositionsRefreshInterval);
	if (userOrdersRefreshInterval !== undefined) clearInterval(userOrdersRefreshInterval);
	if (userOrdersHistoryRefreshInterval !== undefined)
		clearInterval(userOrdersHistoryRefreshInterval);
	if (userHistoryRefreshInterval !== undefined) clearInterval(userHistoryRefreshInterval);
	if (userAllMarginsRefreshInterval !== undefined) clearInterval(userAllMarginsRefreshInterval);
	if (userTradingSeasonStatRefresh !== undefined) clearInterval(userTradingSeasonStatRefresh);
	if (userStratPositionsRefreshInterval !== undefined)
		clearInterval(userStratPositionsRefreshInterval);
}
//market refresh
let marketRefreshInterval: ReturnType<typeof setInterval>;
let stablesRefreshInterval: ReturnType<typeof setInterval>;

export function setupMarketDataRefresh() {
	destroyMarketDatarefresh();
	marketRefreshInterval = setInterval(() => {
		getAllMarkets();
	}, MARKET_DATA_REFRESH);
}

export function destroyMarketDatarefresh() {
	if (marketRefreshInterval !== undefined) clearInterval(marketRefreshInterval);
	if (stablesRefreshInterval !== undefined) clearInterval(stablesRefreshInterval);
}

export function setupStablePriceDataRefresh() {
	getStablesPrices(get(userBalances));

	stablesRefreshInterval = setInterval(() => {
		getStablesPrices(get(userBalances));
	}, STABLES_PRICE_DATA_REFRESH_MATCHA);
}
